// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__36R_A","logo":"Header_logo__2XG30"};